import React from "react"
import { withStyles } from "@material-ui/core/styles"

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "50%",
    paddingTop: 40,
    [theme.breakpoints.up("xl")]: {
      //width: "25%",
      paddingTop: 0,
    },
    // [theme.breakpoints.down("sm")]: {
    //   width: "50%",
    // },
  },
  innerCol: {
    display: "inline-flex",
    flexDirection: "column",
  },
})

const FooterNav = ({ children, classes }) => (
  <div className={classes.root}>
    <div className={classes.innerCol}>{children}</div>
  </div>
)

export default withStyles(styles)(FooterNav)
